// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file wavin/blaze/v1/blaze_device_service.proto (package wavin.blaze.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Device, Device_ReleaseMode, DeviceSchema } from "./device_pb";
import { file_wavin_blaze_v1_device } from "./device_pb";
import type { DeviceAccessKey, DeviceAccessKeySchema } from "./device_access_key_pb";
import { file_wavin_blaze_v1_device_access_key } from "./device_access_key_pb";
import type { DeviceClaim, DeviceClaimSchema } from "./device_claim_pb";
import { file_wavin_blaze_v1_device_claim } from "./device_claim_pb";
import type { DeviceConfig } from "./device_config_pb";
import { file_wavin_blaze_v1_device_config } from "./device_config_pb";
import type { DeviceUpdaterSchema } from "./device_updater_pb";
import { file_wavin_blaze_v1_device_updater } from "./device_updater_pb";
import type { Firmware, FirmwareSchema } from "./firmware_pb";
import { file_wavin_blaze_v1_firmware } from "./firmware_pb";
import type { BrokerConfig, BrokerConfigSchema } from "../../sentio/v1/broker_pb";
import { file_wavin_sentio_v1_broker } from "../../sentio/v1/broker_pb";
import type { BrokerMeasurementSchema } from "../../sentio/v1/broker_measurement_pb";
import { file_wavin_sentio_v1_broker_measurement } from "../../sentio/v1/broker_measurement_pb";
import type { RoomMeasurementSchema } from "../../sentio/v1/room_measurement_pb";
import { file_wavin_sentio_v1_room_measurement } from "../../sentio/v1/room_measurement_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wavin/blaze/v1/blaze_device_service.proto.
 */
export const file_wavin_blaze_v1_blaze_device_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_google_protobuf_empty, file_google_protobuf_timestamp, file_wavin_blaze_v1_device, file_wavin_blaze_v1_device_access_key, file_wavin_blaze_v1_device_claim, file_wavin_blaze_v1_device_config, file_wavin_blaze_v1_device_updater, file_wavin_blaze_v1_firmware, file_wavin_sentio_v1_broker, file_wavin_sentio_v1_broker_measurement, file_wavin_sentio_v1_room_measurement]);

/**
 * @generated from message wavin.blaze.v1.GetDeviceRequest
 */
export type GetDeviceRequest = Message<"wavin.blaze.v1.GetDeviceRequest"> & {
  /**
   * Resource name of device, format: devices/{device}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Include source data
   *
   * @generated from field: bool include_source = 2;
   */
  includeSource: boolean;
};

/**
 * Describes the message wavin.blaze.v1.GetDeviceRequest.
 * Use `create(GetDeviceRequestSchema)` to create a new message.
 */
export const GetDeviceRequestSchema: GenMessage<GetDeviceRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 0);

/**
 * @generated from message wavin.blaze.v1.SetDeviceReleaseModeRequest
 */
export type SetDeviceReleaseModeRequest = Message<"wavin.blaze.v1.SetDeviceReleaseModeRequest"> & {
  /**
   * Resource name of device, format: devices/{device}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: wavin.blaze.v1.Device.ReleaseMode release_mode = 2;
   */
  releaseMode: Device_ReleaseMode;
};

/**
 * Describes the message wavin.blaze.v1.SetDeviceReleaseModeRequest.
 * Use `create(SetDeviceReleaseModeRequestSchema)` to create a new message.
 */
export const SetDeviceReleaseModeRequestSchema: GenMessage<SetDeviceReleaseModeRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 1);

/**
 * @generated from message wavin.blaze.v1.ListDevicesRequest
 */
export type ListDevicesRequest = Message<"wavin.blaze.v1.ListDevicesRequest"> & {
  /**
   * Requested page size. Server may return fewer items than requested.
   * If unspecified, server will pick an appropriate default.
   *
   * @generated from field: int64 page_size = 1;
   */
  pageSize: bigint;

  /**
   * A token identifying a page of results the server should return.
   *
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * Number of results to skip after page_token
   *
   * @generated from field: int64 skip = 3;
   */
  skip: bigint;
};

/**
 * Describes the message wavin.blaze.v1.ListDevicesRequest.
 * Use `create(ListDevicesRequestSchema)` to create a new message.
 */
export const ListDevicesRequestSchema: GenMessage<ListDevicesRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 2);

/**
 * @generated from message wavin.blaze.v1.ListDevicesResponse
 */
export type ListDevicesResponse = Message<"wavin.blaze.v1.ListDevicesResponse"> & {
  /**
   * @generated from field: repeated wavin.blaze.v1.Device devices = 1;
   */
  devices: Device[];

  /**
   * A token to retrieve next page of results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message wavin.blaze.v1.ListDevicesResponse.
 * Use `create(ListDevicesResponseSchema)` to create a new message.
 */
export const ListDevicesResponseSchema: GenMessage<ListDevicesResponse> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 3);

/**
 * @generated from message wavin.blaze.v1.ResetDeviceRequest
 */
export type ResetDeviceRequest = Message<"wavin.blaze.v1.ResetDeviceRequest"> & {
  /**
   * Resource name of device, format: devices/{device}
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message wavin.blaze.v1.ResetDeviceRequest.
 * Use `create(ResetDeviceRequestSchema)` to create a new message.
 */
export const ResetDeviceRequestSchema: GenMessage<ResetDeviceRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 4);

/**
 * @generated from message wavin.blaze.v1.SendDeviceConfigRequest
 */
export type SendDeviceConfigRequest = Message<"wavin.blaze.v1.SendDeviceConfigRequest"> & {
  /**
   * Resource name of device, format: devices/{device}
   *
   * @generated from field: string device_name = 1;
   */
  deviceName: string;

  /**
   * Device config with only changed properties (set on the wire will be applied)
   *
   * @generated from field: wavin.blaze.v1.DeviceConfig config = 2;
   */
  config?: DeviceConfig;
};

/**
 * Describes the message wavin.blaze.v1.SendDeviceConfigRequest.
 * Use `create(SendDeviceConfigRequestSchema)` to create a new message.
 */
export const SendDeviceConfigRequestSchema: GenMessage<SendDeviceConfigRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 5);

/**
 * @generated from message wavin.blaze.v1.StreamDeviceRequest
 */
export type StreamDeviceRequest = Message<"wavin.blaze.v1.StreamDeviceRequest"> & {
  /**
   * Resource names of devices, format: devices/{device}
   *
   * @generated from field: repeated string device_names = 1;
   */
  deviceNames: string[];

  /**
   * Attributes of stream
   *
   * @generated from field: map<string, string> attributes = 2;
   */
  attributes: { [key: string]: string };

  /**
   * Include device.last_config only when config has changed. Default: last_config is included when device changed.
   *
   * @generated from field: bool include_config_on_change_only = 3;
   */
  includeConfigOnChangeOnly: boolean;

  /**
   * Include source data
   *
   * @generated from field: bool include_source = 4;
   */
  includeSource: boolean;
};

/**
 * Describes the message wavin.blaze.v1.StreamDeviceRequest.
 * Use `create(StreamDeviceRequestSchema)` to create a new message.
 */
export const StreamDeviceRequestSchema: GenMessage<StreamDeviceRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 6);

/**
 * @generated from message wavin.blaze.v1.StreamDeviceResponse
 */
export type StreamDeviceResponse = Message<"wavin.blaze.v1.StreamDeviceResponse"> & {
  /**
   * Resource name of device, format: devices/{device}
   *
   * @generated from field: string device_name = 1;
   */
  deviceName: string;

  /**
   * Attributes of stream
   *
   * @generated from field: map<string, string> attributes = 2;
   */
  attributes: { [key: string]: string };

  /**
   * Last known device state (in case of error, last known state is also sent to allow recovery)
   *
   * @generated from field: wavin.blaze.v1.Device device = 3;
   */
  device?: Device;
};

/**
 * Describes the message wavin.blaze.v1.StreamDeviceResponse.
 * Use `create(StreamDeviceResponseSchema)` to create a new message.
 */
export const StreamDeviceResponseSchema: GenMessage<StreamDeviceResponse> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 7);

/**
 * @generated from message wavin.blaze.v1.CreateDeviceAccessKeyRequest
 */
export type CreateDeviceAccessKeyRequest = Message<"wavin.blaze.v1.CreateDeviceAccessKeyRequest"> & {
  /**
   * Resource name of parent device, format: devices/{device}
   *
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: wavin.blaze.v1.DeviceAccessKey access_key = 2;
   */
  accessKey?: DeviceAccessKey;
};

/**
 * Describes the message wavin.blaze.v1.CreateDeviceAccessKeyRequest.
 * Use `create(CreateDeviceAccessKeyRequestSchema)` to create a new message.
 */
export const CreateDeviceAccessKeyRequestSchema: GenMessage<CreateDeviceAccessKeyRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 8);

/**
 * @generated from message wavin.blaze.v1.DeleteDeviceAccessKeyRequest
 */
export type DeleteDeviceAccessKeyRequest = Message<"wavin.blaze.v1.DeleteDeviceAccessKeyRequest"> & {
  /**
   * Resource name of device access key to be deleted, format: devices/{device}/access-keys/{access-key}
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message wavin.blaze.v1.DeleteDeviceAccessKeyRequest.
 * Use `create(DeleteDeviceAccessKeyRequestSchema)` to create a new message.
 */
export const DeleteDeviceAccessKeyRequestSchema: GenMessage<DeleteDeviceAccessKeyRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 9);

/**
 * @generated from message wavin.blaze.v1.ListDeviceAccessKeysRequest
 */
export type ListDeviceAccessKeysRequest = Message<"wavin.blaze.v1.ListDeviceAccessKeysRequest"> & {
  /**
   * Resource name of parent device, format: devices/{device}
   *
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * Requested page size. Server may return fewer items than requested.
   * If unspecified, server will pick an appropriate default.
   *
   * @generated from field: int64 page_size = 2;
   */
  pageSize: bigint;

  /**
   * A token identifying a page of results the server should return.
   *
   * @generated from field: string page_token = 3;
   */
  pageToken: string;

  /**
   * Number of results to skip after page_token
   *
   * @generated from field: int64 skip = 4;
   */
  skip: bigint;
};

/**
 * Describes the message wavin.blaze.v1.ListDeviceAccessKeysRequest.
 * Use `create(ListDeviceAccessKeysRequestSchema)` to create a new message.
 */
export const ListDeviceAccessKeysRequestSchema: GenMessage<ListDeviceAccessKeysRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 10);

/**
 * @generated from message wavin.blaze.v1.ListDeviceAccessKeysResponse
 */
export type ListDeviceAccessKeysResponse = Message<"wavin.blaze.v1.ListDeviceAccessKeysResponse"> & {
  /**
   * @generated from field: repeated wavin.blaze.v1.DeviceAccessKey access_keys = 1;
   */
  accessKeys: DeviceAccessKey[];

  /**
   * A token to retrieve next page of results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message wavin.blaze.v1.ListDeviceAccessKeysResponse.
 * Use `create(ListDeviceAccessKeysResponseSchema)` to create a new message.
 */
export const ListDeviceAccessKeysResponseSchema: GenMessage<ListDeviceAccessKeysResponse> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 11);

/**
 * @generated from message wavin.blaze.v1.CreateDeviceClaimRequest
 */
export type CreateDeviceClaimRequest = Message<"wavin.blaze.v1.CreateDeviceClaimRequest"> & {
  /**
   * @generated from oneof wavin.blaze.v1.CreateDeviceClaimRequest.identification_method
   */
  identificationMethod: {
    /**
     * Registration key on device or from QR code: format: XXXXX-XXXXX-XXXX
     *
     * @generated from field: string registration_key = 1;
     */
    value: string;
    case: "registrationKey";
  } | {
    /**
     * Serial number on device
     *
     * @generated from field: string serial_number = 2;
     */
    value: string;
    case: "serialNumber";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message wavin.blaze.v1.CreateDeviceClaimRequest.
 * Use `create(CreateDeviceClaimRequestSchema)` to create a new message.
 */
export const CreateDeviceClaimRequestSchema: GenMessage<CreateDeviceClaimRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 12);

/**
 * @generated from message wavin.blaze.v1.CreateDeviceClaimByKeyRequest
 */
export type CreateDeviceClaimByKeyRequest = Message<"wavin.blaze.v1.CreateDeviceClaimByKeyRequest"> & {
  /**
   * @generated from oneof wavin.blaze.v1.CreateDeviceClaimByKeyRequest.identification_method
   */
  identificationMethod: {
    /**
     * Registration key on device or from QR code: format: XXXXX-XXXXX-XXXX
     *
     * @generated from field: string registration_key = 1;
     */
    value: string;
    case: "registrationKey";
  } | {
    /**
     * Serial number on device
     *
     * @generated from field: string serial_number = 2;
     */
    value: string;
    case: "serialNumber";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from oneof wavin.blaze.v1.CreateDeviceClaimByKeyRequest.key
   */
  key: {
    /**
     * The device claim is valid for 14 days
     *
     * @generated from field: string ccu_access_code = 3;
     */
    value: string;
    case: "ccuAccessCode";
  } | {
    /**
     * The device claim is valid for the period defined when access_key is generated: format XXXX-XXXX-XXXX-XXXX
     *
     * @generated from field: string access_key = 4;
     */
    value: string;
    case: "accessKey";
  } | {
    /**
     * The device claim is permanently valid
     *
     * @generated from field: string installer_password = 5;
     */
    value: string;
    case: "installerPassword";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message wavin.blaze.v1.CreateDeviceClaimByKeyRequest.
 * Use `create(CreateDeviceClaimByKeyRequestSchema)` to create a new message.
 */
export const CreateDeviceClaimByKeyRequestSchema: GenMessage<CreateDeviceClaimByKeyRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 13);

/**
 * @generated from message wavin.blaze.v1.DeleteDeviceClaimRequest
 */
export type DeleteDeviceClaimRequest = Message<"wavin.blaze.v1.DeleteDeviceClaimRequest"> & {
  /**
   * Resource name of device claim to be deleted, format: devices/{device}
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message wavin.blaze.v1.DeleteDeviceClaimRequest.
 * Use `create(DeleteDeviceClaimRequestSchema)` to create a new message.
 */
export const DeleteDeviceClaimRequestSchema: GenMessage<DeleteDeviceClaimRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 14);

/**
 * @generated from message wavin.blaze.v1.DeleteAllDeviceClaimsRequest
 */
export type DeleteAllDeviceClaimsRequest = Message<"wavin.blaze.v1.DeleteAllDeviceClaimsRequest"> & {
};

/**
 * Describes the message wavin.blaze.v1.DeleteAllDeviceClaimsRequest.
 * Use `create(DeleteAllDeviceClaimsRequestSchema)` to create a new message.
 */
export const DeleteAllDeviceClaimsRequestSchema: GenMessage<DeleteAllDeviceClaimsRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 15);

/**
 * @generated from message wavin.blaze.v1.ListDeviceClaimsRequest
 */
export type ListDeviceClaimsRequest = Message<"wavin.blaze.v1.ListDeviceClaimsRequest"> & {
  /**
   * Resource name of parent device, format: devices/{device}
   *
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * Requested page size. Server may return fewer items than requested.
   * If unspecified, server will pick an appropriate default.
   *
   * @generated from field: int64 page_size = 2;
   */
  pageSize: bigint;

  /**
   * A token identifying a page of results the server should return.
   *
   * @generated from field: string page_token = 3;
   */
  pageToken: string;

  /**
   * Number of results to skip after page_token
   *
   * @generated from field: int64 skip = 4;
   */
  skip: bigint;
};

/**
 * Describes the message wavin.blaze.v1.ListDeviceClaimsRequest.
 * Use `create(ListDeviceClaimsRequestSchema)` to create a new message.
 */
export const ListDeviceClaimsRequestSchema: GenMessage<ListDeviceClaimsRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 16);

/**
 * @generated from message wavin.blaze.v1.ListDeviceClaimsResponse
 */
export type ListDeviceClaimsResponse = Message<"wavin.blaze.v1.ListDeviceClaimsResponse"> & {
  /**
   * @generated from field: repeated wavin.blaze.v1.DeviceClaim claims = 1;
   */
  claims: DeviceClaim[];

  /**
   * A token to retrieve next page of results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message wavin.blaze.v1.ListDeviceClaimsResponse.
 * Use `create(ListDeviceClaimsResponseSchema)` to create a new message.
 */
export const ListDeviceClaimsResponseSchema: GenMessage<ListDeviceClaimsResponse> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 17);

/**
 * @generated from message wavin.blaze.v1.UpdateDeviceFirmwareRequest
 */
export type UpdateDeviceFirmwareRequest = Message<"wavin.blaze.v1.UpdateDeviceFirmwareRequest"> & {
  /**
   * The resource name of a device, format: devices/{device}
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message wavin.blaze.v1.UpdateDeviceFirmwareRequest.
 * Use `create(UpdateDeviceFirmwareRequestSchema)` to create a new message.
 */
export const UpdateDeviceFirmwareRequestSchema: GenMessage<UpdateDeviceFirmwareRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 18);

/**
 * @generated from message wavin.blaze.v1.CreateFirmwareRequest
 */
export type CreateFirmwareRequest = Message<"wavin.blaze.v1.CreateFirmwareRequest"> & {
  /**
   * @generated from field: bytes firmware_package = 1;
   */
  firmwarePackage: Uint8Array;
};

/**
 * Describes the message wavin.blaze.v1.CreateFirmwareRequest.
 * Use `create(CreateFirmwareRequestSchema)` to create a new message.
 */
export const CreateFirmwareRequestSchema: GenMessage<CreateFirmwareRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 19);

/**
 * @generated from message wavin.blaze.v1.DeleteFirmwareRequest
 */
export type DeleteFirmwareRequest = Message<"wavin.blaze.v1.DeleteFirmwareRequest"> & {
  /**
   * The resource name of a firmware, format: firmwares/{firmware}
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message wavin.blaze.v1.DeleteFirmwareRequest.
 * Use `create(DeleteFirmwareRequestSchema)` to create a new message.
 */
export const DeleteFirmwareRequestSchema: GenMessage<DeleteFirmwareRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 20);

/**
 * @generated from message wavin.blaze.v1.ListFirmwaresRequest
 */
export type ListFirmwaresRequest = Message<"wavin.blaze.v1.ListFirmwaresRequest"> & {
  /**
   * Requested page size. Server may return fewer items than requested.
   * If unspecified, server will pick an appropriate default.
   *
   * @generated from field: int64 page_size = 1;
   */
  pageSize: bigint;

  /**
   * A token identifying a page of results the server should return.
   *
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * Number of results to skip after page_token
   *
   * @generated from field: int64 skip = 3;
   */
  skip: bigint;
};

/**
 * Describes the message wavin.blaze.v1.ListFirmwaresRequest.
 * Use `create(ListFirmwaresRequestSchema)` to create a new message.
 */
export const ListFirmwaresRequestSchema: GenMessage<ListFirmwaresRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 21);

/**
 * @generated from message wavin.blaze.v1.ListFirmwaresResponse
 */
export type ListFirmwaresResponse = Message<"wavin.blaze.v1.ListFirmwaresResponse"> & {
  /**
   * @generated from field: repeated wavin.blaze.v1.Firmware firmwares = 1;
   */
  firmwares: Firmware[];

  /**
   * A token to retrieve next page of results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message wavin.blaze.v1.ListFirmwaresResponse.
 * Use `create(ListFirmwaresResponseSchema)` to create a new message.
 */
export const ListFirmwaresResponseSchema: GenMessage<ListFirmwaresResponse> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 22);

/**
 * @generated from message wavin.blaze.v1.DownloadFirmwareRequest
 */
export type DownloadFirmwareRequest = Message<"wavin.blaze.v1.DownloadFirmwareRequest"> & {
  /**
   * The resource name of a firmware, format: firmwares/{firmware}
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message wavin.blaze.v1.DownloadFirmwareRequest.
 * Use `create(DownloadFirmwareRequestSchema)` to create a new message.
 */
export const DownloadFirmwareRequestSchema: GenMessage<DownloadFirmwareRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 23);

/**
 * @generated from message wavin.blaze.v1.ReleaseFirmwareGARequest
 */
export type ReleaseFirmwareGARequest = Message<"wavin.blaze.v1.ReleaseFirmwareGARequest"> & {
  /**
   * Firmware resource name, format: firmwares/{firmware}
   *
   * @generated from field: string firmware_name = 1;
   */
  firmwareName: string;
};

/**
 * Describes the message wavin.blaze.v1.ReleaseFirmwareGARequest.
 * Use `create(ReleaseFirmwareGARequestSchema)` to create a new message.
 */
export const ReleaseFirmwareGARequestSchema: GenMessage<ReleaseFirmwareGARequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 24);

/**
 * @generated from message wavin.blaze.v1.PatchFirmwareRequest
 */
export type PatchFirmwareRequest = Message<"wavin.blaze.v1.PatchFirmwareRequest"> & {
  /**
   * @generated from field: wavin.blaze.v1.Firmware firmware = 1;
   */
  firmware?: Firmware;
};

/**
 * Describes the message wavin.blaze.v1.PatchFirmwareRequest.
 * Use `create(PatchFirmwareRequestSchema)` to create a new message.
 */
export const PatchFirmwareRequestSchema: GenMessage<PatchFirmwareRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 25);

/**
 * @generated from message wavin.blaze.v1.GetDeviceUpdaterRequest
 */
export type GetDeviceUpdaterRequest = Message<"wavin.blaze.v1.GetDeviceUpdaterRequest"> & {
  /**
   * DeviceUpdater resource name, format: devices/{device}/updater
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Firmware resource name, format: firmwares/{firmware}
   * Current device state will be checked for compatibility with this firmware package
   *
   * @generated from field: optional string firmware_name = 2;
   */
  firmwareName?: string;
};

/**
 * Describes the message wavin.blaze.v1.GetDeviceUpdaterRequest.
 * Use `create(GetDeviceUpdaterRequestSchema)` to create a new message.
 */
export const GetDeviceUpdaterRequestSchema: GenMessage<GetDeviceUpdaterRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 26);

/**
 * @generated from message wavin.blaze.v1.StartDeviceUpdaterRequest
 */
export type StartDeviceUpdaterRequest = Message<"wavin.blaze.v1.StartDeviceUpdaterRequest"> & {
  /**
   * DeviceUpdater resource name, format: devices/{device}/updater
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Firmware resource name, format: firmwares/{firmware}
   *
   * @generated from field: string firmware_name = 2;
   */
  firmwareName: string;

  /**
   * Component names that needs to be flashed to given firmware
   *
   * @generated from field: repeated string component_names = 3;
   */
  componentNames: string[];
};

/**
 * Describes the message wavin.blaze.v1.StartDeviceUpdaterRequest.
 * Use `create(StartDeviceUpdaterRequestSchema)` to create a new message.
 */
export const StartDeviceUpdaterRequestSchema: GenMessage<StartDeviceUpdaterRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 27);

/**
 * @generated from message wavin.blaze.v1.StreamSentioBrokerConfigRequest
 */
export type StreamSentioBrokerConfigRequest = Message<"wavin.blaze.v1.StreamSentioBrokerConfigRequest"> & {
  /**
   * Device resource name, format: devices/{device}
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message wavin.blaze.v1.StreamSentioBrokerConfigRequest.
 * Use `create(StreamSentioBrokerConfigRequestSchema)` to create a new message.
 */
export const StreamSentioBrokerConfigRequestSchema: GenMessage<StreamSentioBrokerConfigRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 28);

/**
 * @generated from message wavin.blaze.v1.SendSentioBrokerConfigRequest
 */
export type SendSentioBrokerConfigRequest = Message<"wavin.blaze.v1.SendSentioBrokerConfigRequest"> & {
  /**
   * Resource name of device, format: devices/{device}
   *
   * @generated from field: string device_name = 1;
   */
  deviceName: string;

  /**
   * Device config with only changed properties (set on the wire will be applied)
   *
   * @generated from field: wavin.sentio.v1.BrokerConfig config = 2;
   */
  config?: BrokerConfig;
};

/**
 * Describes the message wavin.blaze.v1.SendSentioBrokerConfigRequest.
 * Use `create(SendSentioBrokerConfigRequestSchema)` to create a new message.
 */
export const SendSentioBrokerConfigRequestSchema: GenMessage<SendSentioBrokerConfigRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 29);

/**
 * @generated from message wavin.blaze.v1.UpdateDevicePlatformRequest
 */
export type UpdateDevicePlatformRequest = Message<"wavin.blaze.v1.UpdateDevicePlatformRequest"> & {
  /**
   * Resource name of device, format: devices/{device}
   *
   * @generated from field: string device_name = 1;
   */
  deviceName: string;
};

/**
 * Describes the message wavin.blaze.v1.UpdateDevicePlatformRequest.
 * Use `create(UpdateDevicePlatformRequestSchema)` to create a new message.
 */
export const UpdateDevicePlatformRequestSchema: GenMessage<UpdateDevicePlatformRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 30);

/**
 * @generated from message wavin.blaze.v1.GetSentioBrokerTimeSeriesRequest
 */
export type GetSentioBrokerTimeSeriesRequest = Message<"wavin.blaze.v1.GetSentioBrokerTimeSeriesRequest"> & {
  /**
   * Resource name of device, format: devices/{device}
   *
   * @generated from field: string device_name = 1;
   */
  deviceName: string;

  /**
   * Start time of range
   *
   * @generated from field: google.protobuf.Timestamp start_time = 2;
   */
  startTime?: Timestamp;

  /**
   * End time of range
   *
   * @generated from field: google.protobuf.Timestamp end_time = 3;
   */
  endTime?: Timestamp;

  /**
   * Only numeric measurements
   *
   * @generated from field: bool numeric_only = 4;
   */
  numericOnly: boolean;
};

/**
 * Describes the message wavin.blaze.v1.GetSentioBrokerTimeSeriesRequest.
 * Use `create(GetSentioBrokerTimeSeriesRequestSchema)` to create a new message.
 */
export const GetSentioBrokerTimeSeriesRequestSchema: GenMessage<GetSentioBrokerTimeSeriesRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 31);

/**
 * @generated from message wavin.blaze.v1.GetSentioRoomTimeSeriesRequest
 */
export type GetSentioRoomTimeSeriesRequest = Message<"wavin.blaze.v1.GetSentioRoomTimeSeriesRequest"> & {
  /**
   * Resource name of device, format: devices/{device}
   *
   * @generated from field: string device_name = 1;
   */
  deviceName: string;

  /**
   * Start time of range
   *
   * @generated from field: google.protobuf.Timestamp start_time = 2;
   */
  startTime?: Timestamp;

  /**
   * End time of range
   *
   * @generated from field: google.protobuf.Timestamp end_time = 3;
   */
  endTime?: Timestamp;

  /**
   * Room id
   *
   * @generated from field: string room_id = 4;
   */
  roomId: string;
};

/**
 * Describes the message wavin.blaze.v1.GetSentioRoomTimeSeriesRequest.
 * Use `create(GetSentioRoomTimeSeriesRequestSchema)` to create a new message.
 */
export const GetSentioRoomTimeSeriesRequestSchema: GenMessage<GetSentioRoomTimeSeriesRequest> = /*@__PURE__*/
  messageDesc(file_wavin_blaze_v1_blaze_device_service, 32);

/**
 * BlazeDeviceService is the service for connecting clients to blaze.
 * Methods are executed for identity in authentication token.
 *
 * @generated from service wavin.blaze.v1.BlazeDeviceService
 */
export const BlazeDeviceService: GenService<{
  /**
   * Get device
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.GetDevice
   */
  getDevice: {
    methodKind: "unary";
    input: typeof GetDeviceRequestSchema;
    output: typeof DeviceSchema;
  },
  /**
   * Set release mode device
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.SetDeviceReleaseMode
   */
  setDeviceReleaseMode: {
    methodKind: "unary";
    input: typeof SetDeviceReleaseModeRequestSchema;
    output: typeof DeviceSchema;
  },
  /**
   * List devices
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.ListDevices
   */
  listDevices: {
    methodKind: "unary";
    input: typeof ListDevicesRequestSchema;
    output: typeof ListDevicesResponseSchema;
  },
  /**
   * Reset device (only device data is reset, user device data is kept)
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.ResetDevice
   */
  resetDevice: {
    methodKind: "unary";
    input: typeof ResetDeviceRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * SendDeviceConfig sends a config update to device.
   * Device config changes and errors will be sent back over stream, returns error if device is unavailable.
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.SendDeviceConfig
   */
  sendDeviceConfig: {
    methodKind: "unary";
    input: typeof SendDeviceConfigRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Start stream with one or more devices
   * On stream start the last known device information is streamed back for given resources (or error if offline).
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.StreamDevice
   */
  streamDevice: {
    methodKind: "server_streaming";
    input: typeof StreamDeviceRequestSchema;
    output: typeof StreamDeviceResponseSchema;
  },
  /**
   * Create a device access key that can be used for claiming a device
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.CreateDeviceAccessKey
   */
  createDeviceAccessKey: {
    methodKind: "unary";
    input: typeof CreateDeviceAccessKeyRequestSchema;
    output: typeof DeviceAccessKeySchema;
  },
  /**
   * Delete a device access key to revoke option to claim a device
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.DeleteDeviceAccessKey
   */
  deleteDeviceAccessKey: {
    methodKind: "unary";
    input: typeof DeleteDeviceAccessKeyRequestSchema;
    output: typeof DeviceAccessKeySchema;
  },
  /**
   * List access keys for device including users who generated the access key
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.ListDeviceAccessKeys
   */
  listDeviceAccessKeys: {
    methodKind: "unary";
    input: typeof ListDeviceAccessKeysRequestSchema;
    output: typeof ListDeviceAccessKeysResponseSchema;
  },
  /**
   * Create a device claim gives user permission to access a device
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.CreateDeviceClaim
   */
  createDeviceClaim: {
    methodKind: "server_streaming";
    input: typeof CreateDeviceClaimRequestSchema;
    output: typeof DeviceClaimSchema;
  },
  /**
   * Create a device claim by key gives user instant permission to access a device if the key is correct.
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.CreateDeviceClaimByKey
   */
  createDeviceClaimByKey: {
    methodKind: "unary";
    input: typeof CreateDeviceClaimByKeyRequestSchema;
    output: typeof DeviceClaimSchema;
  },
  /**
   * Delete a device claim removes user permission to access a device
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.DeleteDeviceClaim
   */
  deleteDeviceClaim: {
    methodKind: "unary";
    input: typeof DeleteDeviceClaimRequestSchema;
    output: typeof DeviceClaimSchema;
  },
  /**
   * Delete all device claims removes all user permissions to access all devices
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.DeleteAllDeviceClaims
   */
  deleteAllDeviceClaims: {
    methodKind: "unary";
    input: typeof DeleteAllDeviceClaimsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * List claims for device including users who claimed the device
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.ListDeviceClaims
   */
  listDeviceClaims: {
    methodKind: "unary";
    input: typeof ListDeviceClaimsRequestSchema;
    output: typeof ListDeviceClaimsResponseSchema;
  },
  /**
   * UpdateFirmware will start firmware update to latest available version.
   * Status can be checked in device.firmware_update_status
   * Firmware update status will also be sent back over stream, but device can be unavailable during update.
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.UpdateDeviceFirmware
   */
  updateDeviceFirmware: {
    methodKind: "unary";
    input: typeof UpdateDeviceFirmwareRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Create firmware allows users to upload a firmware package. Returns firmware excluding binary package.
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.CreateFirmware
   */
  createFirmware: {
    methodKind: "unary";
    input: typeof CreateFirmwareRequestSchema;
    output: typeof FirmwareSchema;
  },
  /**
   * Delete firmware allows users to delete firmware package. Returns firmware excluding binary package.
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.DeleteFirmware
   */
  deleteFirmware: {
    methodKind: "unary";
    input: typeof DeleteFirmwareRequestSchema;
    output: typeof FirmwareSchema;
  },
  /**
   * ListFirmwares lists available firmware packages, excluding the package bytes
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.ListFirmwares
   */
  listFirmwares: {
    methodKind: "unary";
    input: typeof ListFirmwaresRequestSchema;
    output: typeof ListFirmwaresResponseSchema;
  },
  /**
   * DownloadFirmware returns the specified firmware package, including package bytes
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.DownloadFirmware
   */
  downloadFirmware: {
    methodKind: "unary";
    input: typeof DownloadFirmwareRequestSchema;
    output: typeof FirmwareSchema;
  },
  /**
   * ReleaseFirmwareAutomatic starts the release process for all devices in RELEASE_MODE_AUTOMATIC
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.ReleaseFirmwareGA
   */
  releaseFirmwareGA: {
    methodKind: "unary";
    input: typeof ReleaseFirmwareGARequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * PatchFirmware allows users to update firmware fields
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.PatchFirmware
   */
  patchFirmware: {
    methodKind: "unary";
    input: typeof PatchFirmwareRequestSchema;
    output: typeof FirmwareSchema;
  },
  /**
   * DeviceUpdater return device updater to track firmware update process
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.GetDeviceUpdater
   */
  getDeviceUpdater: {
    methodKind: "unary";
    input: typeof GetDeviceUpdaterRequestSchema;
    output: typeof DeviceUpdaterSchema;
  },
  /**
   * StartDeviceUpdater will start firmware flash of given components (RELEASE_MODE_MANUAL)
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.StartDeviceUpdater
   */
  startDeviceUpdater: {
    methodKind: "unary";
    input: typeof StartDeviceUpdaterRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * StreamSentioBrokerConfig starts broker config stream with a device.
   * On stream start the full broker config is streamed or error if offline.
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.StreamSentioBrokerConfig
   */
  streamSentioBrokerConfig: {
    methodKind: "server_streaming";
    input: typeof StreamSentioBrokerConfigRequestSchema;
    output: typeof BrokerConfigSchema;
  },
  /**
   * SendSentioBrokerConfig sends broker config changes to device.
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.SendSentioBrokerConfig
   */
  sendSentioBrokerConfig: {
    methodKind: "unary";
    input: typeof SendSentioBrokerConfigRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Update device platform from legacy to current
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.UpdateDevicePlatform
   */
  updateDevicePlatform: {
    methodKind: "unary";
    input: typeof UpdateDevicePlatformRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * GetSentioBrokerTimeSeries returns all broker value measurements in given range as a bounded stream (ordered from oldest to newest timestamp)
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.GetSentioBrokerTimeSeries
   */
  getSentioBrokerTimeSeries: {
    methodKind: "server_streaming";
    input: typeof GetSentioBrokerTimeSeriesRequestSchema;
    output: typeof BrokerMeasurementSchema;
  },
  /**
   * GetSentioRoomTimeSeries returns all room measurements in given range as a bounded stream (ordered from oldest to newest timestamp)
   *
   * @generated from rpc wavin.blaze.v1.BlazeDeviceService.GetSentioRoomTimeSeries
   */
  getSentioRoomTimeSeries: {
    methodKind: "server_streaming";
    input: typeof GetSentioRoomTimeSeriesRequestSchema;
    output: typeof RoomMeasurementSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_wavin_blaze_v1_blaze_device_service, 0);

